import Card from '../components/common/Card';
import ContactForm from '../components/contact/ContactForm';
import PageHero from '../components/layout/PageHero';

function Contact() {
  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Contact FactorStreet"
        description="Reach out for business, product, project, or collaboration conversations."
      />
      <section className="section page-content">
        <div className="container contact-page-grid">
          <Card className="contact-info-card">
            <div className="contact-info-block">
              <h2>Business inquiries</h2>
              <p>
                Share project, partnership, and company-related inquiries with the FactorStreet team.
              </p>
              <a className="contact-email" href="mailto:hello@factorstreet.com">
                hello@factorstreet.com
              </a>
            </div>
            <div className="contact-info-block">
              <h2>Join our Team</h2>
              <p>
                Interested in building practical digital products with us? Send your profile to our hiring team.
              </p>
              <a className="contact-email" href="mailto:hr@factorstreet.com">
                hr@factorstreet.com
              </a>
            </div>
          </Card>
          <Card className="contact-form-card">
            <h2>Send an enquiry</h2>
            <p>Share the essentials and the FactorStreet team will follow up.</p>
            <ContactForm />
          </Card>
        </div>
      </section>
    </>
  );
}

export default Contact;
